import { ShieldCheck, Clock, Truck } from "lucide-react";

const STATS = [
  { icon: Clock, value: "24h", label: "Disponibilidade" },
  { icon: Truck, value: "+500", label: "Atendimentos" },
  { icon: ShieldCheck, value: "100%", label: "Seguranca" },
];

export default function About() {
  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="py-24 sm:py-32 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Text */}
          <div>
            <div className="inline-block bg-[#FFD700] text-black px-3 py-1 text-xs font-bold uppercase tracking-widest mb-6">
              Sobre nos
            </div>
            <h2
              data-testid="about-title"
              className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight uppercase mb-6 leading-tight"
              style={{ fontFamily: "'Oswald', sans-serif" }}
            >
              Solucoes rapidas e{" "}
              <span className="text-[#FFD700]">seguras</span>
            </h2>
            <p className="text-gray-300 text-base sm:text-lg leading-relaxed mb-6">
              Na Huck Guincho 24HS, oferecemos solucoes rapidas e seguras para
              remocao de veiculos em Navirai e regiao. Atuamos 24 horas por dia,
              com equipamentos modernos e equipe preparada para qualquer
              situacao, desde panes simples ate remocoes mais complexas.
            </p>
            <p className="text-gray-400 text-base leading-relaxed">
              Nosso compromisso e chegar rapido, atender bem e resolver seu
              problema com seguranca.
            </p>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-4">
            {STATS.map(({ icon: Icon, value, label }) => (
              <div
                key={label}
                className="bg-[#1A1A1A] border border-[#27272A] p-6 text-center rounded-sm"
              >
                <Icon className="w-8 h-8 text-[#FFD700] mx-auto mb-3" />
                <div
                  className="text-3xl sm:text-4xl font-black text-[#FFD700] mb-1"
                  style={{ fontFamily: "'Oswald', sans-serif" }}
                >
                  {value}
                </div>
                <div className="text-xs sm:text-sm text-gray-400 uppercase tracking-wider font-medium">
                  {label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
